module.exports = __webpack_public_path__ + "img/live-right.9219ec2d.svg";